import { Phone, ChevronRight, CircleCheck as CheckCircle2, ShieldCheck, Star, ArrowRight, Clock, Lock } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
const HERO_IMG = {
  desktop: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/repair-hero-desktop.png",
  tablet: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/repair-hero-desktop.png",
  mobile: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/repair-hero-desktop.png"
};
const NAVY = "#081438";
const NAVY_LIGHT = "#243752";
const GOLD = "#F5A623";
const FONT_HEAD = "'Plus Jakarta Sans', system-ui, sans-serif";
const FONT_BODY = "'Manrope', system-ui, sans-serif";
export default function RepairHero() {
  const formFooterItems = [{
    label: "100% Free",
    icon: ShieldCheck
  }, {
    label: "Fast Response",
    icon: Clock
  }, {
    label: "Private & Secure",
    icon: Lock
  }];
  return <section className="relative isolate overflow-hidden !bg-[url(https://goldgaragedoor.com.au/wp-content/uploads/2026/05/9ada9b93-909d-463a-a8f5-c673b2a6de54.webp)] !bg-[url(https://goldgaragedoor.com.au/wp-content/uploads/2026/05/9ada9b93-909d-463a-a8f5-c673b2a6de54.webp)] !bg-[url(https://goldgaragedoor.com.au/wp-content/uploads/2026/05/9ada9b93-909d-463a-a8f5-c673b2a6de54.webp)] !bg-[url(https://goldgaragedoor.com.au/wp-content/uploads/2026/05/9ada9b93-909d-463a-a8f5-c673b2a6de54.webp)] !bg-[url(https://goldgaragedoor.com.au/wp-content/uploads/2026/05/9ada9b93-909d-463a-a8f5-c673b2a6de54.webp)] !bg-[url(https://goldgaragedoor.com.au/wp-content/uploads/2026/05/9ada9b93-909d-463a-a8f5-c673b2a6de54.webp)] !bg-[url(https://goldgaragedoor.com.au/wp-content/uploads/2026/05/9ada9b93-909d-463a-a8f5-c673b2a6de54.webp)] !bg-[url(https://goldgaragedoor.com.au/wp-content/uploads/2026/06/98e6b5da-5f28-4e7a-9644-2bf8351ab70d-1.webp)] !bg-[url(https://goldgaragedoor.com.au/wp-content/uploads/2026/06/technician-garage-door-repair-768.webp)]" style={{
    backgroundColor: NAVY
  }} aria-label="Garage Door Repair Sydney">
      {}
      <picture className="absolute inset-0 -z-10">
        <source media="(max-width: 767px)" srcSet={HERO_IMG.mobile} type="image/webp" />
        <source media="(max-width: 1279px)" srcSet={HERO_IMG.tablet} type="image/webp" />
        <img src={HERO_IMG.desktop} data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/repair-hero-desktop.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/repair-hero-desktop.png-wvc-sizes" alt="Gold Garage Door technician repairing a garage door spring in Sydney" className="h-full w-full object-cover" style={{
        objectPosition: "65% center"
      }} loading="eager"
      // @ts-ignore
      fetchpriority="high" decoding="async" width={1920} height={1440} />
      </picture>

      {}
      <div className="absolute inset-0 -z-10" style={{
      background: `linear-gradient(90deg, ${NAVY}F2 0%, ${NAVY}E6 40%, ${NAVY}B3 70%, ${NAVY}80 100%)`
    }} />
      <div className="absolute inset-0 -z-10" style={{
      background: `radial-gradient(ellipse at 20% 50%, ${NAVY_LIGHT}66 0%, transparent 50%), linear-gradient(180deg, ${NAVY}40 0%, transparent 30%, transparent 70%, ${NAVY} 100%)`
    }} />

      {}
      <div aria-hidden className="absolute inset-0 -z-10 opacity-[0.05] mix-blend-overlay pointer-events-none" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.9 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")"
    }} />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-8 pt-28 md:pt-32 lg:pt-36 pb-20 md:pb-24 lg:pb-28">
        {}
        <nav aria-label="Breadcrumb" className="mb-10 flex items-center gap-2 text-[13px]" style={{
        fontFamily: FONT_BODY,
        color: "rgba(255,255,255,0.6)"
      }}>
          <Link to="/" className="hover:text-white transition-colors">Home</Link>
          <ChevronRight className="h-3.5 w-3.5 opacity-50" />
          <Link to="#" className="hover:text-white transition-colors">
            Services
          </Link>
          <ChevronRight className="h-3.5 w-3.5 opacity-50" />
          <span style={{
          color: "rgba(255,255,255,0.95)"
        }}>Garage Door Repair</span>
        </nav>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-start">

          {}
          <div className="lg:col-span-7">
            {}
            <div className="mb-6 inline-flex items-center gap-2.5 rounded-lg border px-4 py-2" style={{
            backgroundColor: "rgba(245,166,35,0.10)",
            borderColor: "rgba(245,166,35,0.30)"
          }}>
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-lg opacity-75" style={{
                backgroundColor: GOLD
              }} />
                <span className="relative inline-flex h-2 w-2 rounded-lg" style={{
                backgroundColor: GOLD
              }} />
              </span>
              <span className="text-[11px] font-semibold tracking-[0.18em] uppercase" style={{
              fontFamily: FONT_BODY,
              color: GOLD
            }}>
                Same-Day · Sydney Wide
              </span>
            </div>

            {}
            <h1 className="font-extrabold text-white" style={{
            fontFamily: FONT_HEAD,
            fontSize: "clamp(2.25rem, 5vw, 4.25rem)",
            lineHeight: 1.05,
            letterSpacing: "-0.025em"
          }}>
              Sydney&rsquo;s Trusted{" "}
              <span style={{
              color: GOLD
            }}>Garage Door</span> Repair Experts
            </h1>

            {}
            <p className="mt-6 max-w-xl text-base md:text-lg leading-relaxed" style={{
            fontFamily: FONT_BODY,
            color: "rgba(255,255,255,0.82)"
          }}>Springs, motors, cables, panels, tracks, openers — fixed fast with <span className="text-white font-semibold">fixed-price quotes</span>, <span className="text-white font-semibold">no call-out fees</span>, and a workmanship warranty. Family-run · Fully insured · 5.0 rated.</p>

            {}
            <div className="mt-8 flex flex-col sm:flex-row flex-wrap items-stretch sm:items-center gap-3">
              <Link to="tel:0485000933" aria-label="Call Gold Garage Door on 0485 000 933" className="group inline-flex items-center justify-center gap-3 rounded-lg px-7 py-[14px] text-[15px] font-bold transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]" style={{
              backgroundColor: GOLD,
              color: NAVY,
              fontFamily: FONT_BODY,
              boxShadow: `0 14px 40px -10px ${GOLD}99`
            }}>
                <Phone className="h-[18px] w-[18px]" strokeWidth={2.5} />
                Call 0485 000 933
              </Link>
              <Link to="https://wa.me/61485000933" className="group inline-flex items-center justify-center gap-2 rounded-lg border-2 px-7 py-3 text-[15px] font-semibold text-white transition-all duration-200" style={{
              borderColor: "rgba(255,255,255,0.35)",
              fontFamily: FONT_BODY
            }} onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.10)";
              e.currentTarget.style.borderColor = "rgba(255,255,255,0.55)";
            }} onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.borderColor = "rgba(255,255,255,0.35)";
            }}>
                WhatsApp Us
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </div>

            {}
            <ul className="mt-10 flex flex-wrap gap-x-6 gap-y-3" style={{
            fontFamily: FONT_BODY
          }}>
              {[{
              icon: CheckCircle2,
              label: "Same-Day Service"
            }, {
              icon: ShieldCheck,
              label: "Workmanship Warranty"
            }, {
              icon: Star,
              label: "5.0 Google Rated"
            }].map(({
              icon: Icon,
              label
            }, i) => <li key={label} data-index={i} className="flex items-center gap-2.5">
                  <Icon className="h-[18px] w-[18px] flex-shrink-0" strokeWidth={2} style={{
                color: GOLD
              } as React.CSSProperties} />
                  <span className="text-sm font-medium" style={{
                color: "rgba(255,255,255,0.92)"
              }}>
                    {label}
                  </span>
                </li>)}
            </ul>
          </div>

          {}
          <div id="contact-us" className="lg:col-span-5 scroll-mt-28">
            <div className="relative bg-white backdrop-blur-sm border border-[#F5A623]/40 p-6 md:p-8 rounded-lg shadow-2xl">
              {}
              <div className="absolute -top-px left-6 right-6 h-px" style={{
              background: `linear-gradient(90deg, transparent, ${GOLD} 50%, transparent)`
            }} />

              <div className="mb-6">
                <div className="text-[11px] font-bold tracking-[0.2em] uppercase mb-2" style={{
                fontFamily: FONT_BODY,
                color: GOLD
              }}>
                  Free Quote — 60 seconds
                </div>
                <h2 className="font-bold" style={{
                fontFamily: FONT_HEAD,
                fontSize: "clamp(1.5rem, 2.2vw, 1.875rem)",
                lineHeight: 1.15,
                letterSpacing: "-0.015em",
                color: NAVY
              }}>
                  Get Your Free Quote
                </h2>
                <p className="mt-2 text-sm font-medium" style={{
                fontFamily: FONT_BODY,
                color: NAVY
              }}>
                  Fast response · No obligation · No hidden fees
                </p>
              </div>

              <FormProvider formId="hero_quote_form" sectionName="RepairHero" defaultValues={{
              name: '',
              phone: '',
              suburb: '',
              service: ''
            }}>
                <QuoteFormContent footerItems={formFooterItems} />
              </FormProvider>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-px" style={{
      background: `linear-gradient(90deg, transparent 0%, ${GOLD}80 50%, transparent 100%)`
    }} />
    </section>;
}
function QuoteFormContent({
  footerItems
}: {
  footerItems: any[];
}) {
  const {
    handleSubmit,
    isSubmitted,
    control,
    isSubmitting
  } = useWvcForm();
  const GOLD = "#F5A623";
  const NAVY = "#081438";
  const FONT_BODY = "'Manrope', system-ui, sans-serif";
  const inputClasses = "bg-gradient-to-b from-white to-[#f9f9f9] border-[#F5A623]/40 focus:ring-0 focus:shadow-[0_0_0_3px_rgba(245,166,35,0.1)] transition-all duration-200";
  if (isSubmitted) {
    return <div className="flex flex-col items-center justify-center py-10 text-center" style={{
      fontFamily: FONT_BODY
    }}>
        <CheckCircle2 className="h-12 w-12 mb-3" style={{
        color: GOLD
      }} />
        <div className="font-semibold text-lg" style={{
        color: NAVY
      }}>
          Thank You!
        </div>
        <p className="mt-1 text-sm" style={{
        color: NAVY
      }}>
          We&rsquo;ll be in touch within minutes.
        </p>
      </div>;
  }
  return <>
      <Form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <FormField control={control} name="name" rules={{
          required: "Name is required"
        }} render={({
          field
        }) => <FormItem>
                <FormControl>
                  <Input placeholder="Your Name" className={inputClasses} {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>} />
          <FormField control={control} name="phone" rules={{
          required: "Phone is required"
        }} render={({
          field
        }) => <FormItem>
                <FormControl>
                  <Input placeholder="Phone Number" className={inputClasses} {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>} />
        </div>
        <FormField control={control} name="suburb" rules={{
        required: "Suburb is required"
      }} render={({
        field
      }) => <FormItem>
              <FormControl>
                <Input placeholder="Suburb / Postcode" className={inputClasses} {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
        <FormField control={control} name="service" render={({
        field
      }) => <FormItem>
              <FormControl>
                <Input placeholder="What needs fixing? (e.g. Broken Spring)" className={inputClasses} {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
        <Button type="submit" disabled={isSubmitting} className="w-full py-6 text-base font-bold rounded-lg transition-all duration-200 hover:scale-[1.01] active:scale-[0.99]" style={{
        backgroundColor: GOLD,
        color: NAVY
      }}>
          {isSubmitting ? "Sending..." : "Get My Free Quote"}
        </Button>
      </Form>

      {}
      <div className="mt-6 pt-4 border-t border-black/5 flex items-center justify-between gap-3 flex-wrap" style={{
      fontFamily: FONT_BODY
    }}>
        {footerItems.map(({
        label,
        icon: Icon
      }, i) => <div key={label} data-index={i} className="flex items-center gap-1.5">
            <Icon className="h-3.5 w-3.5" style={{
          color: GOLD
        } as React.CSSProperties} />
            <span className="text-[11px] font-bold uppercase tracking-wider" style={{
          color: GOLD
        }}>
              {label}
            </span>
          </div>)}
      </div>
    </>;
}